import React from "react"
import { LayoutContextProvider } from "./LayoutContext"
import { CommonContextProvider } from "./CommanContext" 

export const CombinedContext = ({ children }) => {
  return (
    <LayoutContextProvider>
      <CommonContextProvider>{children}</CommonContextProvider>
    </LayoutContextProvider>
  )
}
